import { ICON_PATHS } from './icons/generated';

import type { IconName } from './icons/generated';

export type { IconName };

/** Íconos de línea del prototipo (design/icons): decorativos salvo que lleven `label`. */
export function Icon({ name, size = 24, label }: { name: IconName; size?: number; label?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(label === undefined ? { 'aria-hidden': true } : { role: 'img', 'aria-label': label })}
    >
      {ICON_PATHS[name]}
    </svg>
  );
}
